const ru = {
  app: {
    name: 'W&M',
    fullName: 'W&M Vending',
    tagline: 'Управление торговыми автоматами',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Изменить',
    back: 'Назад',
    search: 'Поиск',
    actions: 'Действия',
    total: 'Итого',
    all: 'Все',
    refresh: 'Обновить',
    retry: 'Повторить',
    exportCsv: 'Экспорт CSV',
    viewAll: 'Смотреть все',
    open: 'Открыть',
    more: 'Ещё',
    loading: 'Загрузка…',
    currency: 'сум',
    pcs: 'шт.',
    days: 'дн.',
    noValue: '—',
    optional: 'необязательно',
  },
  nav: {
    sectionMain: 'Основное',
    sectionManage: 'Управление',
    dashboard: 'Главная',
    checkout: 'Касса',
    reports: 'Отчёты',
    createReport: 'Отправить отчёт',
    users: 'Сотрудники',
    branches: 'Филиалы',
    products: 'Склад',
    collapse: 'Свернуть панель',
    expand: 'Развернуть панель',
    openMenu: 'Открыть меню',
    home: 'Главная',
  },
  header: {
    breadcrumb: 'Навигационная цепочка',
    search: 'Поиск…',
    searchShortcut: 'Ctrl K',
    notifications: 'Уведомления',
    noNotifications: 'Новых уведомлений нет',
    allGood: 'Всё в порядке',
    lowStockItem: 'На складе осталось {{count}} шт.',
    outOfStockItem: 'Нет на складе',
    theme: 'Тема',
    language: 'Язык',
    profile: 'Профиль',
    editProfile: 'Редактировать профиль',
    logout: 'Выйти',
    administrator: 'Администратор',
    employee: 'Сотрудник',
  },
  theme: {
    system: 'Системная',
    light: 'Светлая',
    dark: 'Тёмная',
    night: 'Ночная',
  },
  search: {
    placeholder: 'Найти страницу, товар, филиал или сотрудника…',
    pages: 'Страницы',
    products: 'Товары',
    branches: 'Филиалы',
    users: 'Сотрудники',
    empty: 'Ничего не найдено',
    hintNavigate: 'выбор',
    hintOpen: 'открыть',
    hintClose: 'закрыть',
  },
  filters: {
    period: 'Период',
    today: 'Сегодня',
    yesterday: 'Вчера',
    last7: '7 дней',
    last30: '30 дней',
    thisMonth: 'Этот месяц',
    custom: 'Свой период',
    branch: 'Филиал',
    allBranches: 'Все филиалы',
    product: 'Товар',
    allProducts: 'Все товары',
    productsSelected: 'Товаров: {{count}}',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    reset: 'Сбросить фильтры',
  },
  dashboard: {
    title: 'Панель управления',
    subtitle: 'Продажи, склад и филиалы с первого взгляда',
    kpi: {
      revenue: 'Общая выручка',
      today: 'Выручка за сегодня',
      units: 'Продано товаров',
      profit: 'Валовая прибыль',
      avgDaily: 'Средняя выручка в день',
      stock: 'Остаток на складе',
      lowStock: 'Заканчивающиеся товары',
      branches: 'Филиалы с продажами',
    },
    vsPrevious: 'к прошлому периоду',
    vsYesterday: 'ко вчерашнему дню',
    noComparison: 'Нет данных для сравнения',
    skuCount: 'Наименований: {{count}}',
    lowStockHint: '{{count}} шт. и меньше',
    branchesHint: 'из {{count}} филиалов',
    margin: 'Маржа: {{value}}',
    daysWithSales: 'Дней с продажами: {{count}}',
    productFilterNote: 'Фильтр по товарам не применяется',
    allInStock: 'Все товары в наличии',
    openReports: 'Подробный отчёт',
  },
  charts: {
    salesDynamics: 'Динамика продаж',
    salesDynamicsSub: 'По дням, в сравнении с прошлым периодом',
    current: 'Текущий период',
    previous: 'Прошлый период',
    revenue: 'Выручка',
    profit: 'Прибыль',
    units: 'Продано, шт.',
    cost: 'Себестоимость',
    revenueVsCost: 'Выручка и себестоимость',
    revenueVsCostSub: 'Выручка = себестоимость + валовая прибыль',
    byBranch: 'Выручка по филиалам',
    byBranchSub: 'Доля филиалов за выбранный период',
    topProducts: 'Топ-5 товаров',
    topProductsSub: 'По количеству продаж',
    productShare: 'Доля товаров',
    productShareSub: 'Распределение по проданным штукам',
    others: 'Прочие',
    share: 'Доля',
    totalUnits: 'всего шт.',
    dailyProfit: 'Изменение прибыли по дням',
    productProfit: 'Прибыль по товарам',
    singleBranch: 'Выберите «Все филиалы», чтобы сравнить филиалы',
  },
  tables: {
    recentDays: 'Последние дни продаж',
    recentDaysSub: 'Выручка, продажи и прибыль по дням',
    date: 'Дата',
    lowStock: 'Заканчивающиеся товары',
    lowStockSub: 'Остаток {{count}} шт. и меньше',
    remaining: 'Остаток',
    rowsTotal: '{{from}}–{{to}} из {{total}}',
  },
  states: {
    emptyTitle: 'Данные не найдены',
    emptyPeriod: 'За выбранный период продаж нет',
    emptyHint: 'Попробуйте выбрать другой период или филиал',
    emptySearch: 'По запросу ничего не найдено',
    emptySearchHint: 'Попробуйте изменить запрос',
    errorTitle: 'Не удалось загрузить данные',
    errorHint: 'Ошибка соединения с сервером. Попробуйте ещё раз.',
  },
  checkout: {
    title: 'Касса',
    subtitle: 'Ежедневная выручка: {{branch}}',
    total: 'Итого за период',
    avgDay: 'В среднем за день',
    bestDay: 'Лучший день',
    days: 'Дней с продажами',
    daily: 'Выручка по дням',
    dailySub: 'Поступления в кассу за каждый день',
  },
  reports: {
    title: 'Отчёты',
    titleFor: 'Отчёт: {{branch}}',
    subtitle: 'Продажи в разрезе товаров и дней',
    productName: 'Название товара',
    quantity: 'Кол-во',
    profit: 'Прибыль',
    overall: 'Итого',
    total: 'Итого',
    exportName: 'otchet',
  },
  createReport: {
    title: 'Отправить отчёт',
    subtitle: 'Укажите проданные за день товары по филиалу',
    branch: 'Филиал',
    branchPlaceholder: 'Выберите филиал',
    date: 'Дата',
    searchProduct: 'Поиск товара',
    searchPlaceholder: 'Название товара',
    soldQuantity: 'Продано',
    products: 'Товары',
    filled: 'Заполнено товаров: {{count}}',
    totalUnits: 'Итого: {{count}} шт.',
    negativeError: 'Количество проданных товаров не может быть меньше 0',
    inStock: 'На складе: {{count}}',
  },
  users: {
    title: 'Сотрудники',
    subtitle: 'Пользователи системы и их филиалы',
    add: 'Добавить сотрудника',
    name: 'Сотрудник',
    branches: 'Закреплённые филиалы',
    noBranches: 'Филиалы не закреплены',
    searchPlaceholder: 'Поиск сотрудника',
    createTitle: 'Новый сотрудник',
    createSubtitle: 'Создайте логин и пароль для входа в систему',
    editTitle: 'Обновление данных',
    editSubtitle: 'Изменение логина, email и пароля',
    login: 'Логин',
    loginPlaceholder: 'Введите логин',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    emailHint: 'На этот адрес придёт код для восстановления пароля',
    emailInvalid: 'Некорректный email',
    noEmail: 'Email не указан',
    emailMissingTitle: 'Укажите email',
    emailMissingText: 'Email не указан. Если вы забудете пароль, восстановить его не получится.',
    password: 'Пароль',
    passwordPlaceholder: 'Введите пароль',
    newPasswordHint: 'Оставьте пустым, чтобы не менять пароль',
    loginMin: 'Логин должен содержать не менее 4 символов',
    passwordMin: 'Пароль должен содержать не менее 4 символов',
    pages: 'Доступ к страницам',
    pagesHint: 'Сотрудник видит только отмеченные страницы',
    pagesRequired: 'Отметьте хотя бы одну страницу',
    count: 'Сотрудников: {{count}}',
  },
  branches: {
    title: 'Филиалы',
    subtitle: 'Точки продаж, ответственные сотрудники и цены',
    add: 'Добавить филиал',
    name: 'Название филиала',
    namePlaceholder: 'Например: Филиал Чиланзар',
    staff: 'Закреплённые сотрудники',
    staffPlaceholder: 'Выберите сотрудников',
    noStaff: 'Сотрудники не закреплены',
    prices: 'Цены',
    reports: 'Отчёты',
    searchPlaceholder: 'Поиск филиала',
    createTitle: 'Новый филиал',
    createSubtitle: 'Укажите название и закрепите сотрудников',
    editTitle: 'Редактирование филиала',
    editSubtitle: 'Название филиала и ответственные сотрудники',
    pricesTitle: '{{branch}} — цены',
    pricesSubtitle: 'Цены продажи товаров в филиале',
    editPrices: 'Изменить цены',
    editPricesTitle: '{{branch}} — изменение цен',
    editPricesSubtitle: 'Укажите цену продажи для каждого товара',
    sellPrice: 'Цена продажи',
    pricePlaceholder: 'Цена',
    count: 'Филиалов: {{count}}',
  },
  products: {
    title: 'Склад',
    subtitle: 'Товары, остатки и цены в филиалах',
    create: 'Новый товар',
    addStock: 'Оприходовать',
    name: 'Название товара',
    namePlaceholder: 'Введите название товара',
    searchPlaceholder: 'Поиск товара',
    stock: 'Остаток',
    buyPrice: 'Цена закупки',
    buyPricePlaceholder: 'Введите цену',
    quantity: 'Количество',
    quantityPlaceholder: 'Введите количество',
    branchPrices: 'Цены продажи в филиалах',
    branchPricesHint: 'Укажите цену продажи для каждого филиала',
    searchBranch: 'Поиск филиала',
    sellPrice: 'Цена продажи',
    createTitle: 'Новый товар',
    createSubtitle: 'Данные товара и цены в филиалах',
    editTitle: 'Редактирование товара',
    editSubtitle: 'Данные товара и цены в филиалах',
    addStockTitle: 'Поступление на склад',
    addStockSubtitle: 'Укажите поступившее количество для каждого товара',
    addQuantity: 'Поступило',
    currentStock: 'Текущий остаток: {{count}}',
    negativeError: 'Количество товара не может быть меньше 0',
    statusOk: 'В наличии',
    statusLow: 'Заканчивается',
    statusOut: 'Нет в наличии',
    count: 'Товаров: {{count}}',
    filterAll: 'Все',
    filterLow: 'Заканчиваются',
    general: 'Основные данные',
  },
  confirm: {
    deleteTitle: 'Подтвердите удаление',
    deleteText: 'Вы действительно хотите удалить? Это действие нельзя отменить.',
  },
  notify: {
    created: '{{entity}}: успешно создано',
    updated: '{{entity}}: успешно обновлено',
    deleted: '{{entity}}: успешно удалено',
    added: '{{entity}}: успешно добавлено',
    createError: '{{entity}}: ошибка при создании',
    updateError: '{{entity}}: ошибка при обновлении',
    deleteError: '{{entity}}: ошибка при удалении',
    addError: '{{entity}}: ошибка при добавлении',
    loginSuccess: 'Добро пожаловать!',
    loginError: 'Неверный логин или пароль',
    logoutSuccess: 'Вы вышли из системы',
    logoutError: 'Ошибка при выходе',
    entities: {
      user: 'Сотрудник',
      branch: 'Филиал',
      product: 'Товар',
      report: 'Отчёт',
      prices: 'Цены',
    },
  },
  validation: {
    required: 'Заполните поле «{{field}}»',
    min: 'Минимум {{count}} символа',
    nonNegative: 'Значение не может быть меньше 0',
    number: 'Введите число',
  },
  login: {
    title: 'Вход в систему',
    subtitle: 'Войдите в аккаунт, чтобы продолжить',
    login: 'Логин',
    loginPlaceholder: 'Введите логин',
    password: 'Пароль',
    passwordPlaceholder: 'Введите пароль',
    submit: 'Войти',
    forgotPassword: 'Забыли пароль?',
    asideTitle: 'Управляйте сетью торговых автоматов из одной панели',
    asideText: 'Выручка, складские остатки и показатели филиалов в реальном времени.',
    feature1: 'Анализ ежедневной выручки и прибыли',
    feature2: 'Контроль складских остатков',
    feature3: 'Отчёты по филиалам',
  },
  forgotPassword: {
    title: 'Восстановление пароля',
    subtitle: 'Введите email, привязанный к аккаунту, — мы отправим на него 6-значный код подтверждения',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    submit: 'Отправить код',
    backToLogin: 'Вернуться ко входу',
    codeTitle: 'Введите код',
    codeText: '6-значный код подтверждения отправлен на адрес:',
    codeHint: 'Код действует 15 минут. Если письма нет, проверьте папку «Спам».',
    verify: 'Подтвердить',
    resend: 'Отправить код повторно',
    resendIn: 'Отправить повторно ({{count}} с)',
    changeEmail: 'Указать другой email',
  },
  resetPassword: {
    title: 'Новый пароль',
    subtitle: 'Придумайте новый надёжный пароль для аккаунта',
    password: 'Новый пароль',
    passwordPlaceholder: 'Введите новый пароль',
    confirm: 'Подтвердите пароль',
    confirmPlaceholder: 'Введите пароль ещё раз',
    confirmRequired: 'Введите пароль ещё раз',
    mismatch: 'Пароли не совпадают',
    ruleLength: 'Не менее 8 символов',
    ruleLetter: 'Хотя бы одна буква',
    ruleDigit: 'Хотя бы одна цифра',
    submit: 'Сохранить пароль',
    successTitle: 'Пароль обновлён',
    successText: 'Теперь вы можете войти с новым паролем.',
  },
  errors: {
    network: 'Нет связи с сервером. Проверьте подключение к интернету',
    unknown: 'Произошла непредвиденная ошибка. Попробуйте ещё раз',
    too_many_requests: 'Слишком много попыток. Повторите через минуту',
    email_required: 'Введите email',
    email_invalid: 'Некорректный email',
    email_email: 'Некорректный email',
    email_max: 'Слишком длинный email',
    email_unique: 'Этот email уже привязан к другому сотруднику',
    email_not_found: 'Этот email не зарегистрирован в системе',
    mail_failed: 'Не удалось отправить письмо. Попробуйте немного позже',
    login_required: 'Введите логин',
    login_min: 'Логин должен содержать не менее 4 символов',
    login_unique: 'Этот логин занят, выберите другой',
    password_required: 'Введите пароль',
    password_min: 'Пароль должен содержать не менее 4 символов',
    password_weak: 'Пароль должен содержать не менее 8 символов, буквы и цифры',
    user_not_found: 'Пользователь не найден',
    wrong_password: 'Неверный пароль',
    code_required: 'Введите 6-значный код полностью',
    code_invalid: 'Неверный код. Проверьте код из письма и введите снова',
    code_expired: 'Срок действия кода истёк. Запросите новый код',
    code_attempts_exceeded: 'Слишком много неверных попыток. В целях безопасности код аннулирован — запросите новый',
  },
  notFound: {
    title: 'Страница не найдена',
    text: 'Запрошенная страница не существует или была перемещена.',
    home: 'Вернуться на главную',
  },
  errorBoundary: {
    title: 'Произошла непредвиденная ошибка',
    text: 'Попробуйте перезагрузить страницу. Если ошибка повторится, обратитесь к администратору.',
    reload: 'Перезагрузить',
  },
  table: {
    sortAsc: 'По возрастанию',
    sortDesc: 'По убыванию',
    cancelSort: 'Отменить сортировку',
  },
};

export default ru;
